<div
	[formGroup]="controller.form"
	class="flex flex-col items-stretch space-y-1"
>
	<div class="p-1 space-y-1">
		<div
			[innerHTML]="
				controller.baseI18n + 'rating'
					| translate: { moduleName: controller.moduleName$ | async }
			"
		></div>
		<p-rating
			[cancel]="false"
			class="block"
			formControlName="rating"
			stars="5"
		></p-rating>
	</div>
	<div
		*ngIf="
			controller.moduleSuggestions$ | async | nullIfEmpty as moduleSuggestions
		"
		class="space-y-1"
	>
		<div
			[innerHTML]="controller.baseI18n + 'suggestions' | translate"
			class="p-1"
		></div>
		<div>
			<ng-container *ngFor="let moduleSuggestion of moduleSuggestions">
				<div
					*ngIf="moduleSuggestion.orgModule$ | async as orgModule"
					class="
						flex
						items-stretch
						even:border-t-0
						border border-solid border-grey-lime
					"
				>
					<div class="flex-1 px-1 py-3 font-semibold">
						<ng-container
							*ngIf="orgModule.localization$ | async as localization; else noName"
						>
							{{ localization.name }}
						</ng-container>
						<ng-template #noName>-</ng-template>
					</div>
					<div
						*ngIf="controller.sessionUserId$ | async as userId"
						class="
							flex-none
							bg-gray-200
							px-1
							flex
							border-0 border-l border-solid border-gray-300
						"
					>
						<button
							(click)="onModuleClick(orgModule, userId)"
							class="p-button-primary-transparent"
							icon="fas fa-arrow-right"
							pButton
							type="button"
						></button>
					</div>
				</div>
			</ng-container>
		</div>
	</div>
</div>
